import gql from "graphql-tag";

const ORGANIZATION_MEMBER = gql`
  fragment ORGANIZATION_MEMBER on OrganizationMember {
    id
    role
    mfaEnforced
    user {
      id
      isMfaEnabled
      professional {
        id
        type
        profile {
          id
          email
          firstName
          lastName
          gender
          avatarUrl
        }
        medias {
          id
          url
          type
          name
        }
      }
      subscription {
        id
        status
        quantity
        plan {
          id
        }
      }
    }
    updatedAt
    createdAt
  }
`;

export default ORGANIZATION_MEMBER;
